import { VIA_MCP_LABEL, type TicketReplyDraft } from '@easyhelp/shared';
import { formatDateTime, personName } from '../../components/ticket';

/** Testi della bozza di risposta sopra il composer (#159). */

/** «Bozza preparata via MCP da Mario Rossi» o, senza origine MCP, «Bozza preparata da Mario Rossi». */
export function replyDraftByline(draft: Pick<TicketReplyDraft, 'author' | 'viaMcp'>): string {
  return `Bozza preparata ${draft.viaMcp ? `${VIA_MCP_LABEL} ` : ''}da ${personName(draft.author)}`;
}

/** L'annuncio cortese dell'arrivo (o della presenza, all'apertura del ticket) di una bozza. */
export function replyDraftArrivalText(draft: TicketReplyDraft): string {
  return `${replyDraftByline(draft)}, ${formatDateTime(draft.updatedAt)}, sopra il composer: «Usa la bozza» la carica nel testo della risposta.`;
}
